export function send_to_nsfw_splash_if_not_enabled() {
    if (!document.cookie.includes("allow-nsfw=true")){
        window.location.href = "/nsfw-splash?from=" + window.location.pathname;
    }
}

Object.assign(window, {
    send_to_nsfw_splash_if_not_enabled
});